<template>
  <!-- 翠麟云剧场 -->
  <div class="Cinema bg-round bg-fff">
    <el-carousel height="700">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <div class="width100">
          <img
            :src="item.ImageUrl"
            alt=""
            srcset=""
            width="100%"
            height="100%"
            class="img_cover"
          />
        </div>
      </el-carousel-item>
    </el-carousel>
    <div>
      <div class="container">
        <Bread :list="breadList" class="ma-t-10" />
        <!--<div class="flex f-between ma-t-30">
            <div class="width30">
                <div class="c-p" :class="{'font-bold':sortType==0}" @click="sortType=0;loadDataList('refresh')">综合排序</div>
                <div class="flex f-wrap">
                  <div class="ma-t-20 ma-r-20 c-p" :class="{'font-bold':sortType==1}" @click="sortType=1;loadDataList('refresh')">热度最高</div>
                  <div class="ma-t-20 ma-r-20 c-p" :class="{'font-bold':sortType==2}" @click="sortType=2;loadDataList('refresh')">最新上线</div>
                  <div class="ma-t-20 ma-r-20 c-p" :class="{'font-bold':sortType==3}" @click="sortType=3;loadDataList('refresh')">最多播放</div>
                </div>
            </div>
            <div class="width40">
                <div class="c-p" :class="{'font-bold':areas==0}" @click="areas=0;loadDataList('refresh')">全部地区</div>
                <div class="flex f-wrap">
                    <div v-for="(item,index) in areasList" :key="index" class="ma-r-20 ma-t-20 c-p" :class="{'font-bold':areas==item.Id}"  @click="areas=item.Id;loadDataList('refresh')">{{ item.Name }}</div>
                </div>
            </div>
            <div class="width30">
                <div class="c-p" :class="{'font-bold':categoryId==0}" @click="categoryId=0;loadDataList('refresh')">全部类型</div>
                <div class="flex f-wrap">
                    <div v-for="(item,index) in categoryList" :key="index" class="ma-r-20 ma-t-20 c-p" :class="{'font-bold':categoryId==item.Id}"  @click="categoryId=item.Id;loadDataList('refresh')">{{ item.Name }}</div>
                </div>
            </div>
        </div>-->
        <div class="flex f-between ma-t-30">
            <div class="width30">
                <div class="c-p" :class="{'font-bold':sortType==0}" @click="sortType=0;toPage('sortType',0)">综合排序</div>
                <div class="flex f-wrap">
                  <div class="ma-t-20 ma-r-20 c-p" :class="{'font-bold':sortType==1}" @click="toPage('sortType',1)">热度最高</div>
                  <div class="ma-t-20 ma-r-20 c-p" :class="{'font-bold':sortType==2}" @click="toPage('sortType',2)">最新上线</div>
                  <div class="ma-t-20 ma-r-20 c-p" :class="{'font-bold':sortType==3}" @click="toPage('sortType',3)">最多播放</div>
                </div>
            </div>
            <div class="width40">
                <div class="c-p" :class="{'font-bold':areas==0}" @click="toPage('areas',0)">全部地区</div>
                <div class="flex f-wrap">
                    <div v-for="(item,index) in areasList" :key="index" class="ma-r-20 h40 c-p" :class="{'font-bold':areas==item.Id}"  @click="toPage('areas',item.Id)">{{ item.Name }}</div>
                </div>
                
            </div>
            <!--<div class="width40 domicile1">
                <div class="c-p" :class="{'font-bold':areas==0}" @click="toPage('areas',0)">全部地区</div>
                <div :class="isareas?'flex f-wrap':'flex f-wrap h80'">
                    <div v-for="(item,index) in areasList" :key="index" class="ma-r-20 h40 c-p" :class="{'font-bold':areas==item.Id}"  @click="toPage('areas',item.Id)">{{ item.Name }}</div>
                </div>
                <div class="c-0155FF c-p pa-r-20 pa-l-20 bg-fff btnshow" @click="isareas?isareas=flase:isareas=true">
                  <div class="flex f-wrap f-end">
                    <div class="ma-r-20 c-p h40">{{isareas?"隐藏":"展开"}}</div>
                  </div>
                </div>
            </div>-->
            <div class="width30 domicile1">
                <div class="c-p" :class="{'font-bold':categoryId==0}" @click="categoryId=0;toPage('categoryId',0)">全部类型</div>
                <div :class="iscategory?'flex f-wrap':'flex f-wrap h80'">
                    <div v-for="(item,index) in categoryList" :key="index" class="ma-r-20 h40 c-p" :class="{'font-bold':categoryId==item.Id}"  @click="toPage('categoryId',item.Id)">{{ item.Name }}</div>
                </div>
                <div class="c-0155FF c-p pa-r-20 pa-l-20 bg-fff btnshow" @click="iscategory?iscategory=flase:iscategory=true">
                  <div class="flex f-wrap f-end">
                    <div class="ma-r-20 h40 c-p">{{iscategory?"隐藏":"展开"}}</div>
                  </div>
                </div>
            </div>
        </div>

        <div class="flex f-wrap ma-t-30">
            <div class="box-item ma-b-40 t-center c-p" v-for="(item,index) in dataList" :key="index" @click="$router.push({path:'/movie/detail',query:{id:item.Id}})">
                <img :src="item.Image" width="100%" height="80%" class="img_cover b-r-15" alt="" srcset="">
                <div class="ma-t-20">{{ item.Name }}</div>
                <div class="ma-t-10">{{ item.Title }}</div>
            </div>
        </div>
        <Empty :isShow="!dataList || dataList.length==0"></Empty>
        <div class="fy t-center">
        <el-pagination
          @current-change="handleCurrentChange"
          :hide-on-single-page="true"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Bread from "../components/Bread.vue";
  import { getCinemaBanner, getCinemaCategory,getCinemaQueryAreas,getCinemaList } from "../api.js";
    export default {
      components: {
        Bread,
      },
      data() {
        return {
          breadList: [
            {
              name: "翠麟云剧场",
              path: "/movie/index",
            },
          ],
          totals: 0, //一个分类下的总条数
          pageIndex: 1,
          pageSize:16,
          dataList:[],
          bannerList:[],//轮播图列表
          categoryList:[],//全部类型列表
          areasList:[],//全部地区列表
          sortType:0,//搜索条件 排序方式 1：热度最高 2：最新上线 3：最多播放
          areas:0,//搜索条件，全部地区 1
          categoryId:0,//搜索条件，全部动作
          iscategory:false,
          isareas:false,
        };
      },
      activated(){
        this.loadData()
        this.loadDataList()
      },
      methods:{
        // 当前页改变时触发
        handleCurrentChange(e) {
          this.pageIndex = e;
          this.loadDataList()
        },
        toPage(type,e){
          if(type=="sortType"){
            this.$router.push("/Cinema-list?sortType="+e);
          }
          if(type=="areas"){
            this.$router.push("/Cinema-list?areas="+e);
          }
          if(type=="categoryId"){
            this.$router.push("/Cinema-list?categoryId="+e);
          }

        },
        //获取数据
        loadData(){
          getCinemaBanner({type:1}).then(res=>{
            this.bannerList=res.data.Data
          })
          getCinemaCategory().then(res=>{
            this.categoryList=res.data.Data
          })
          getCinemaQueryAreas().then(res=>{
            this.areasList=res.data.Data
          })
        },
        //获取列表
        loadDataList(type){
            if(type=='refresh'){
                this.pageIndex=1
            }
            getCinemaList({
                sortType:this.sortType,
                areas:this.areas,
                categoryId:this.categoryId,
                pageIndex:this.pageIndex,
                pageSize:this.pageSize
            }).then(res=>{
                this.dataList=res.data.Data.List
                this.totals = res.data.Data.TotalCount;
            })
        }
      }
    };
</script>

<style scoped lang="scss">
  .Cinema .container{
      // min-height: 1150px;
      // background: #ffffff;
      box-sizing: border-box;
      padding: 30px 40px;
  }
  .box-item {
      width: 18%;
      height: 320px;
    }
    .box-item:not(:nth-child(5n)) {
      margin-right: calc(10% / 5);
    }
    .btnshow{
      position:absolute;
      bottom:0;
      right:0;
    }
    .h80{
      height:80px;
      overflow:hidden;
    }
    .h40{
      height: 40px;
      line-height: 40px;
    }
</style>